export const BETA_EDITOR_QUERY_KEY = 'beta'

export const hasBetaEditorQuery = (query: Record<string, unknown> | undefined | null) => {
    if (!query) return false

    return Object.prototype.hasOwnProperty.call(query, BETA_EDITOR_QUERY_KEY)
}
